import { render } from "./AffiliationView.vue?vue&type=template&id=bf24049a"
import script from "./AffiliationView.vue?vue&type=script&lang=js"
export * from "./AffiliationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__